import(/* webpackMode: "eager" */ "/builds/riksjatravel/rickshawnetwork-frontend/frontend/src/app/(routes)/[...slug]/error.tsx");
